import * as angular from 'angular';
import { RegentsPlanningTableTransferComponent } from './regents-planning-table-transfer.component';

export const RegentsPlanningTableTransferModule = angular
  .module('regentsPlanningTableTransferModule', [])
  .component('regentsPlanningTableTransfer', RegentsPlanningTableTransferComponent).name;
